import { DealModalComponent } from 'src/app/shared/components/deal-modal/deal-modal.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DealsService } from 'src/app/services/deals.service';
import { GeneralService } from 'src/app/services/general.service';
import { DealModel } from 'src/app/models/deal.model';
import { CurrencyService } from 'src/app/services/currency.service';
import { selectConfig } from 'src/app/utils/utils';

@Component({
  selector: 'app-pipeline',
  templateUrl: './pipeline.component.html',
  styleUrls: ['./pipeline.component.css'],
})
export class PipelineComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(DealModalComponent) dealModal: DealModalComponent;
  @Output() updateDashboard = new EventEmitter();
  @Input() teamID = null;
  @Input() teamList: any[] = null;
  @Input() salepersonID =  null;
  @Input() dealStatus: string = null;
  @Input() clientId: number = null;
  @Input() forecastStatus: string = null;
  @Input() moveDeal = false;
  @Input() showWorkflowList: boolean = true;
  @Input() currentDateFilter: any = null;
  @Input() dateFilterType: string = null;
  @Input() archiveFlag: number = 0;
  @Input() customFilter: any = null;
  private unsubscribe$ = new Subject<void>();
  connectedTo = []; processList: any[];
  loading = true; showPipelineDeal = false;
  config = {...selectConfig, placeholder: 'Select Deal Process'}
  stage; code;
  baseCurrency;
  spinnerType = 'wave';
  processListPrevState = [];
  selectedWorkflow: any = null;

  processForm = new FormGroup({
    processId: new FormControl(''),
  });

  constructor(
    private dealSrv: DealsService,
    private gs: GeneralService,
    private currencySrv: CurrencyService) {

      this.currencySrv.org_currencies.subscribe( org_currencies => {
        if(!this.gs.checkIfObjectIsEmpty(org_currencies)) {
          this.baseCurrency = org_currencies.base_currency;
        }
      });
    // $.getScript('../../../assets/js/datatableScript.js');
  }

  pipelineList = [];
  filteredPipelist = []

  ngOnInit() {
    const savedWorkflow = this.gs.getSelectedWorkflow();
    if (savedWorkflow) {
      this.selectedWorkflow = savedWorkflow;
    }

    this.getData();
    // this.listenForWorkflowId();

    this.processForm.controls.processId.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        if (value && value.id) {
          this.selectedWorkflow = value;
          this.gs.setSelectedWorkflow(value);
        } else if (this.selectedWorkflow) {
          this.selectedWorkflow = null;
          this.gs.setSelectedWorkflow(null);
          this.showPipelineDeal = false;
          this.pipelineList = [];
          this.updateDashboard.emit({ pipelineList: [], processName: '' });
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['teamID'] && !changes['teamID'].firstChange) ||
      (changes['teamList'] && !changes['teamList'].firstChange)) {
      const currentSelection = this.selectedWorkflow || this.processForm.value.processId;

      this.dealSrv.fetchUserPipelineworkflow()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any[]) => {
          this.processListPrevState = this.processList = data;

          if (currentSelection && currentSelection.id) {
            const matchingWorkflow = data.find(w => w.id === currentSelection.id);
            if (matchingWorkflow) {
              this.selectedWorkflow = matchingWorkflow;
              this.processForm.controls.processId.setValue(matchingWorkflow, { emitEvent: false });
              if (this.currentDateFilter && this.currentDateFilter.startDate && this.currentDateFilter.endDate) {
                const dateFilterForm = new FormGroup({
                  startDate: new FormControl(this.currentDateFilter.startDate, Validators.required),
                  endDate: new FormControl(this.currentDateFilter.endDate, Validators.required)
                });
                this.getPipelineDeals(dateFilterForm);
              } else {
                this.getPipelineDeals();
              }
            } else {
              this.selectedWorkflow = null;
              this.gs.setSelectedWorkflow(null);
              this.processForm.controls.processId.setValue(null, { emitEvent: false });
              this.showPipelineDeal = false;
              this.pipelineList = [];
              this.updateDashboard.emit({ pipelineList: [], processName: '' });
            }
          } else {
            this.selectedWorkflow = null;
            this.gs.setSelectedWorkflow(null);
            this.processForm.controls.processId.setValue(null, { emitEvent: false });
            this.showPipelineDeal = false;
            this.pipelineList = [];
            this.updateDashboard.emit({ pipelineList: [], processName: '' });
          }
        });
    }

    const filterInputs = ['currentDateFilter', 'dateFilterType', 'salepersonID', 'dealStatus', 'clientId', 'forecastStatus', 'archiveFlag', 'customFilter'];
    const hasFilterChange = filterInputs.some(input => changes[input] && !changes[input].firstChange);

    if (hasFilterChange) {
      if (!this.selectedWorkflow && (!this.processForm.value.processId || !this.processForm.value.processId.id)) {
        this.showPipelineDeal = false;
        this.pipelineList = [];
        this.updateDashboard.emit({ pipelineList: [], processName: '' });
        return;
      }

      if (this.selectedWorkflow) {
        setTimeout(() => {
          const currentFormValue = this.processForm.value.processId;
          if (!currentFormValue || !currentFormValue.id || currentFormValue.id !== this.selectedWorkflow.id) {
            const workflowFromList = this.processList && this.processList.find(w => w.id === this.selectedWorkflow.id);
            if (workflowFromList) {
              this.processForm.controls.processId.setValue(workflowFromList, { emitEvent: false });
            }
          }
        }, 0);
      }

      if (this.currentDateFilter && this.currentDateFilter.startDate && this.currentDateFilter.endDate) {
        const dateFilterForm = new FormGroup({
          startDate: new FormControl(this.currentDateFilter.startDate, Validators.required),
          endDate: new FormControl(this.currentDateFilter.endDate, Validators.required)
        });
        this.getPipelineDeals(dateFilterForm);
      } else {
        this.getPipelineDeals();
      }
    }
  }

  listenForWorkflowId() {
    this.gs.emitWorkflowId.next(null)
    this.gs.emitWorkflowId.subscribe(res => {
      if(res) {
        this.processForm.controls.processId.setValue(res);
        this.getPipelineDeals()
      }
    })
  }
  getData() {
    this.getProcessList();
  }
  getProcessList() {
    const teamIds = this.teamList ? this.teamList.map((team) => team.teamID) : null;
    const mainTeam = this.teamID==='All'?`${teamIds}`: this.teamID
    this.dealSrv.fetchUserPipelineworkflow()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any[]) => {
       this.processListPrevState = this.processList = data;

       if (this.selectedWorkflow && this.selectedWorkflow.id) {
         const matchingWorkflow = data.find(w => w.id === this.selectedWorkflow.id);
         if (matchingWorkflow) {
           this.processForm.controls.processId.setValue(matchingWorkflow, { emitEvent: false });

           if (this.currentDateFilter && this.currentDateFilter.startDate && this.currentDateFilter.endDate) {
             const dateFilterForm = new FormGroup({
               startDate: new FormControl(this.currentDateFilter.startDate, Validators.required),
               endDate: new FormControl(this.currentDateFilter.endDate, Validators.required)
             });
             this.getPipelineDeals(dateFilterForm);
           } else {
             this.getPipelineDeals();
           }
         }
       }
      });
  }
  reloadPipelineDeals(type) {
    this.spinnerType = 'wave'
    if (this.currentDateFilter && this.currentDateFilter.startDate && this.currentDateFilter.endDate) {
      const dateFilterForm = new FormGroup({
        startDate: new FormControl(this.currentDateFilter.startDate, Validators.required),
        endDate: new FormControl(this.currentDateFilter.endDate, Validators.required)
      });
      this.getPipelineDeals(dateFilterForm);
    } else {
      this.getPipelineDeals();
    }
  }
  changeProcess() {
    const processId = this.processForm.value.processId;

    if (!processId || !processId.id) {
      this.selectedWorkflow = null;
      this.gs.setSelectedWorkflow(null);
      this.showPipelineDeal = false;
      this.pipelineList = [];
      this.updateDashboard.emit({ pipelineList: [], processName: '' });
      return;
    }

    this.selectedWorkflow = processId;
    this.gs.setSelectedWorkflow(processId);

    if (this.currentDateFilter && this.currentDateFilter.startDate && this.currentDateFilter.endDate) {
      const dateFilterForm = new FormGroup({
        startDate: new FormControl(this.currentDateFilter.startDate, Validators.required),
        endDate: new FormControl(this.currentDateFilter.endDate, Validators.required)
      });
      this.getPipelineDeals(dateFilterForm);
    } else {
      this.getPipelineDeals();
    }
  }
  getPipelineDeals(dateFilter?: FormGroup) {
    this.showPipelineDeal = true;
    this.loading = true;
    const { processId } = this.processForm.value;
    const newDateFilter = dateFilter && dateFilter.valid ? dateFilter.value : null;

    const teamIds = this.teamList ? this.teamList.map((team) => team.teamID) : null;
    const mainTeam = this.teamID==='All'?teamIds: this.teamID;
    const teamIdsArray = Array.isArray(mainTeam) ? mainTeam : [mainTeam];

    if (this.customFilter && this.customFilter.id) {
      this.dealSrv.fetchFilteredPipelineDeals(this.customFilter.id, processId.id, teamIdsArray)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          let filteredData = data.pipelineDeals ? data.pipelineDeals : (Array.isArray(data) ? data : []);

          const hasDateFilter = (this.customFilter.createdStartDate && this.customFilter.createdEndDate) || (this.customFilter.closeStartDate && this.customFilter.closeEndDate);

          if (!hasDateFilter) {
            const oneMonthAgo = this.dealSrv.dateUtil.getPrvMntTs();
            filteredData = filteredData.map(stage => ({
              ...stage,
              deals: stage.deals.filter(deal => {
                const createdDate = new Date(deal.createdDate).getTime();
                return createdDate >= oneMonthAgo;
              })
            }));
          }

          this.pipelineList = filteredData;
          this.filteredPipelist = filteredData;
          this.updateDashboard.emit({pipelineList: filteredData, processName: ''});
          for (const pipeline of this.pipelineList) {
            this.connectedTo.push(this.toStr(pipeline.stageID));
          }
          this.loading = false;
        }, err => {
          this.spinnerType = 'errorCard'
          this.gs.emitWorkflowId.next(null);
        });
      return;
    }

    const filter: any = {
      salesperson: this.salepersonID,
      archiveFlag: this.archiveFlag
    };

    if (this.dateFilterType === 'closeDate') {
      filter.closeDate = newDateFilter;
    } else {
      filter.dateFilter = newDateFilter;
    }

    const combinedFilters: any = {};
    let nonDateFilterCount = 0;

    if (this.dealStatus) {
      combinedFilters.status = this.dealStatus;
      nonDateFilterCount++;
    }

    if (this.clientId) {
      combinedFilters.client = {
        client: { id: this.clientId.toString() },
        type: 'Client'
      };
      nonDateFilterCount++;
    }

    if (this.forecastStatus) {
      combinedFilters.forecastStatus = this.forecastStatus;
      nonDateFilterCount++;
    }

    if (this.salepersonID) {
      combinedFilters.creatorId = {
        owner: this.salepersonID
      };
      nonDateFilterCount++;
    }

    if (this.dateFilterType === 'closeDate' && newDateFilter) {
      combinedFilters.closeDate = newDateFilter;
    } else if (newDateFilter) {
      combinedFilters.dateFilter = newDateFilter;
    }

    const filterCount = nonDateFilterCount;

    if (filterCount > 1) {
      this.dealSrv.fetchUnifiedFilteredPipelineDeals(processId.id, combinedFilters, teamIdsArray, this.archiveFlag)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          let filteredData = data.pipelineDeals ? data.pipelineDeals : data;

          if (!combinedFilters.dateFilter && !combinedFilters.closeDate) {
            const oneMonthAgo = this.dealSrv.dateUtil.getPrvMntTs();
            filteredData = filteredData.map(stage => ({
              ...stage,
              deals: stage.deals.filter(deal => {
                const createdDate = new Date(deal.createdDate).getTime();
                return createdDate >= oneMonthAgo;
              })
            }));
          }

          this.pipelineList = filteredData;
          this.filteredPipelist = filteredData;
          this.updateDashboard.emit({pipelineList: filteredData, processName: ''});
          for (const pipeline of this.pipelineList) {
            this.connectedTo.push(this.toStr(pipeline.stageID));
          }
          this.loading = false;
        }, err => {
          this.spinnerType = 'errorCard'
          this.gs.emitWorkflowId.next(null);
        });
    } else {
      this.dealSrv.fetchPipelineDeals(processId.id, mainTeam, filter)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          let filteredData = data.pipelineDeals ? data.pipelineDeals : data;

          if (!newDateFilter) {
            const oneMonthAgo = this.dealSrv.dateUtil.getPrvMntTs();
            filteredData = filteredData.map(stage => ({
              ...stage,
              deals: stage.deals.filter(deal => {
                const createdDate = new Date(deal.createdDate).getTime();
                return createdDate >= oneMonthAgo;
              })
            }));
          }

          if (this.dealStatus) {
            filteredData = filteredData.map(stage => ({
              ...stage,
              deals: stage.deals.filter(deal => {
                const dealStatus = this.getDealStatus(deal);
                return dealStatus === this.dealStatus;
              })
            }));
          }

          if (this.clientId) {
            filteredData = filteredData.map(stage => ({
              ...stage,
              deals: stage.deals.filter(deal => {
                return deal.clientID === this.clientId || deal.clientID === this.clientId.toString();
              })
            }));
          }

          if (this.forecastStatus) {
            filteredData = filteredData.map(stage => ({
              ...stage,
              deals: stage.deals.filter(deal => {
                if (this.forecastStatus === 'FORECAST') {
                  return deal.forecastAmount && deal.forecastAmount > 0;
                } else if (this.forecastStatus === 'NOT_FORECAST') {
                  return !deal.forecastAmount || deal.forecastAmount === 0;
                }
                return true;
              })
            }));
          }

          this.pipelineList = filteredData;
          this.filteredPipelist = filteredData;
          this.updateDashboard.emit({pipelineList: filteredData, processName: ''});
          for (const pipeline of this.pipelineList) {
            this.connectedTo.push(this.toStr(pipeline.stageID));
          }
          this.loading = false;
        }, err => {
          this.spinnerType = 'errorCard'
          this.gs.emitWorkflowId.next(null);
        });
    }
  }

  getDealStatus(deal: any): string {
    if (deal.currStage === 'Won') {
      return 'WON';
    } else if (deal.currStage === 'Lost') {
      return 'LOST';
    } else {
      return 'OPEN';
    }
  }
  getSum(deals: any[]) {
    return this.currencySrv.get_total_converted_value(deals)

    // return deals.reduce((curr, deal) =>  curr + (parseFloat(deal.amount) || 0), 0)
  }

  toStr(param: number) {
    return param.toString();
  }
  toStringify(obj) {
    return JSON.stringify(obj)
  }

  disableDeal(dealStage) {
    if (dealStage === 'Won' || dealStage === 'Lost') {
      return true;
    } else {
      return false;
    }
  }

  changeDealStage(body) {
    this.dealSrv.changeStage(body)
    .pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      if (this.currentDateFilter && this.currentDateFilter.startDate && this.currentDateFilter.endDate) {
        const dateFilterForm = new FormGroup({
          startDate: new FormControl(this.currentDateFilter.startDate, Validators.required),
          endDate: new FormControl(this.currentDateFilter.endDate, Validators.required)
        });
        this.getPipelineDeals(dateFilterForm);
      } else {
        this.getPipelineDeals();
      }
    }, err => {
      this.gs.sweetAlertError(this.gs.getErrMsg(err))
    }).add(() => {
      this.dealModal.loading = false;
      document.getElementById('closeDModal').click();
    });
  }

  onEntered(event: CdkDragDrop<string[]>) {
    const nativeElement = event.item.element.nativeElement;
    const deal: DealModel = JSON.parse(nativeElement.id as any)
    const activeStageIndex = this.pipelineList.findIndex(item => item.stageID == event.item.dropContainer.id);
    const nextStageIndex = this.pipelineList.findIndex(item => item.stageID == event.container.id);
    let moveDealForward = false;

    const findActiveStage = this.pipelineList.find(item => item.stageID == event.item.dropContainer.id);
    const findNextStage = this.pipelineList.find(item => item.stageID == event.container.id);
    const activeStage = {...findActiveStage, id: findActiveStage.stageID, name: findActiveStage.stageName, documents: findActiveStage.document};
    const nextStage = {...findNextStage, id: findNextStage.stageID, name: findNextStage.stageName, documents: findNextStage.document}
      if(activeStageIndex < nextStageIndex){
        moveDealForward = true;
      } else {
        moveDealForward = false;
      }
    if(activeStage.roleName.indexOf(this.gs.roleName) >= 0) {
      if(activeStage.requireValue && this.gs.NoValue(deal.amount) && moveDealForward) {
        this.gs.sweetAlertFieldValidatio('Deal Value is required to move to this stage');
      } else if(activeStage.requireForecast && !deal.forecastAmount && moveDealForward) {
       this.gs.sweetAlertFieldValidatio('Deal Forecast is required to move to this stage');
      } else {
        this.dealModal.getRequiredDoc(activeStage, deal, nextStage, moveDealForward);
        $('#showModal').click();
      }
    } else {
      this.gs.sweetAlertFieldValidatio('You don\'t have permission to move deal to this stage');
    }

  }
  onDrop(event: CdkDragDrop<string[]>) {
    const { id: code} = event.item.element.nativeElement;
    const stage = this.pipelineList.find(item => item.stageID == event.container.id);
    const {stageID, stageName} = stage;
    const body = { stageID, stageName, code};

    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }
  async filterDeal(event) {
    const result = [...this.filteredPipelist]
    const { value } = event.target;
    for (let i = 0; i < this.filteredPipelist.length; i++) {
      const element = this.filteredPipelist[i];
      const deals = element.deals.filter(item => {
        return (item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.clientName.toLowerCase().includes(value.toLowerCase()))
      })
      result[i] = {...result[i], deals}
    }
    this.pipelineList = result
  }
}
